<template>
  <ElPopover
    ref="isPopoverBook"
    v-model:visible="isPopoverVis"
    class="bookmarks-list"
    placement="bottom-end"
    trigger="click"
    popper-class="boookmarks"
  >
    <template v-slot:reference>
      <div
        ref="bookmarkMain"
        :filled="isReportingSettings"
        class="tabs-right-btn__bookmarks"
        :class="{
          'bookmark-title-disabled': isBookmarkTitleDisabled
        }"
      >
        <UiIcon
          name="star"
          :size="13"
          class="bookmark-icon"
          color="#e9a126"
        />
        <!-- <UiIcon
          name="chevron-down"
          :size="9"
          class="tab-action tabs-right-btn__chevron"
          :class="{
            'tabs-right-btn__chevron--open': isPopoverVis
          }"
        /> -->
        <UiCaret
          :open="isPopoverVis"
          :size="10"
        />
      </div>
    </template>
    <div v-loading="isLoadingBookmark">
      <div class="search-input-popover__wrap">
        <UiInput
          v-model="searchBookmarkText"
          is-search
          class="search-input-popover"
          @search="searchBookmark"
          @clear="handleClear"
        />
      </div>
      <div class="list-popover__wrap">
        <div
          v-for="(item, key) in bookmarks"
          :key="item.key"
          class="select-row-popover"
          :class="{
            'popover-open': isPopoverEditIndex === key
          }"
        >
          <div class="select-row-popover__wrap">
            <span
              class="select-row-popover__title"
              @click.stop="handlePushBookmark(key)"
            >
              {{ item.bookmarkName }}
            </span>

            <div class="select-row-popover__wrap-inn">
              <!-- vue3-migration -- slot="reference" слот не в корне -->
              <span
                :class="{
                  'select-row-popover__edit--active': isPopoverEdit[key]
                }"
                class="select-row-popover__edit"
                @click.stop="handleEditBookmarkName(key, item.bookmarkName, false)"
              >{{ $t('profile.buttons.edit') }}</span>
              <span
                :class="{
                  'select-row-popover__delete--active': isPopoverEdit[key]
                }"
                class="select-row-popover__delete"
                @click.stop="handleEditBookmarkName(key, item.bookmarkName, true)"
              >{{ $t('profile.apiKeys.table.delete') }}</span>
            </div>
          </div>
          <div
            class="hide-edit__bookbarks"
            :class="{
              'open-edit__bookbarks': isPopoverEditExpand && isPopoverEditIndex == key
            }"
          >
            <UiInput
              v-if="!openPopupDelete"
              v-model="constBookmarkName"
              :label="$t('customReports.EditBookmark')"
              class="boookmark-edit__input"
            />
            <div
              v-if="openPopupDelete"
              class="delete-text mb-4"
            >
              {{ $t('customReports.sureWeleteBookmark') }}
            </div>
            <div class="boookmark-edit__wrap-btn">
              <button
                class="btn btn-outline-primary btn-sm boookmark-edit__close mr-8"
                @click.stop="handleModalCancel"
              >
                {{ $t('profile.buttons.cancel') }}
              </button>
              <button
                v-if="!openPopupDelete"
                class="btn btn-primary btn-sm boookmark-edit__success"
                @click.stop="handleModalSave(key)"
              >
                {{ $t('profile.buttons.save') }}
              </button>
              <button
                v-if="openPopupDelete"
                class="btn btn-danger btn-sm boookmark-edit__success"
                @click.stop="handleModalDelete(key)"
              >
                {{ $t('profile.apiKeys.table.delete') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="notFoundBookmark">
        <span class="notFoundBookmark">{{ $t('customReports.noBbookmarksFound') }}</span>
      </div>
    </div>
  </ElPopover>
</template>

<script>
import BookmarksMixin from './bookmarks-mixin';

export default {
  mixins: [
    BookmarksMixin,
  ],
  emits: ['update:bookmarks', 'update:isPopoverEditIndex'],
  computed: {
    isReportingSettings() {
      return this.reports[this.currentReport].playersType !== 'all';
    },
    isBookmarkTitleDisabled() {
      return this.bookmarks.length === 0 && this.searchBookmarkText.length === 0;
    },
  },
  data() {
    return {
      isPopoverVis: false,
      isPopoverEdit: [],
      isPopoverEditExpand: false,
      openPopupDelete: false,
      notFoundBookmark: false,
      searchBookmarkText: '',
      constBookmarkName: '',
    };
  },
  async mounted() {
    document.addEventListener('click', this.eventStop, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.eventStop, true);
  },
  methods: {
    eventStop(e) {
      if (this.$refs.bookmarkMain.contains(e.target)) {

      }
    },
    searchBookmark(search) {
      this.searchBookmarkText = search;
      const searchLowerCase = search.toLowerCase();

      this.getBookmarks()
        .then(() => {
          const bookmarks = this.bookmarks
            .filter((e) => e.bookmarkName
              .toLowerCase()
              .indexOf(searchLowerCase) !== -1);

          this.$emit('update:bookmarks', bookmarks);
          this.notFoundBookmark = this.bookmarks.length === 0;
        });
    },
    handleClear() {
      this.searchBookmarkText = '';
      this.searchBookmark(this.searchBookmarkText);
    },
    handlePushBookmark(key) {
      this.isPopoverVis = false;
      this.pushBookmark(key);
    },
    handleEditBookmarkName(key, bookmarkName, openPopupDelete) {
      this.editBookmarkName(key, bookmarkName);
      this.openPopupDelete = openPopupDelete;
    },
    handleModalCancel() {
      this.isPopoverEditExpand = false;
      this.$emit('update:isPopoverEditIndex', null);
    },
    handleModalSave(key) {
      this.saveEditBookmarkName(key);
      this.handleModalCancel();
    },
    handleModalDelete(key) {
      this.deleteBookmark(key);
      this.handleModalCancel();
    },
    saveEditBookmarkName(index) {
      this.bookmarks[index].bookmarkName = this.constBookmarkName;
      this.saveBookmark();
    },
    editBookmarkName(index, name) {
      this.constBookmarkName = name;
      this.$emit('update:isPopoverEditIndex', index);
      // this.isPopoverEditIndex = index;
      this.isPopoverEditExpand = true;
    },
  },
};
</script>
